import { endpoints, request } from '!core/api';

export const tradingServices = {
  loadBook: ({ clientId }) =>
    request.get(endpoints.simo(`loadBookPrimary?clientId=${clientId}`)),
  loadHstBook: ({ clientId, endDate }) =>
    request.get(
      endpoints.simo(
        `loadHstBookPrimary?clientId=${clientId}&startDate=2020-01-01&endDate=${endDate}`,
      ),
    ),
  loadBookStockExchange: ({ clientId }) =>
    request.get(endpoints.simo(`loadBook?clientId=${clientId}`)),
  loadHstBookStockExchange: ({ clientId, endDate }) =>
    request.get(
      endpoints.simo(
        `loadHstBook?clientId=${clientId}&startDate=2020-01-01&endDate=${endDate}`,
      ),
    ),
  loadBookPrimaryPrivate: ({ clientId }) =>
    request.get(endpoints.simo(`loadBookPrimaryPrivate?clientId=${clientId}`)),
  loadHstBookPrimaryPrivate: ({ clientId, endDate }) =>
    request.get(
      endpoints.simo(
        `loadHstBookPrimaryPrivate?clientId=${clientId}&startDate=2020-01-01&endDate=${endDate}`,
      ),
    ),
  loadBookFund: ({ clientId }) =>
    request.get(
      endpoints.simo(`loadBookFund?clientId=${clientId}&securityType=FUND`),
    ),
  loadHstBookFund: ({ clientId, endDate }) =>
    request.get(
      endpoints.simo(
        `loadHstBookFund?clientId=${clientId}&startDate=2020-01-01&endDate=${endDate}&securityType=FUND`,
      ),
    ),
  loadBookEvents: ({ clientId, ordBookKey, bookType }) =>
    request.get(
      endpoints.simo(
        `loadBookEvents?clientId=${clientId}&ordBookKey=${ordBookKey}&bookType=${bookType}&execType=F`,
      ),
    ),
  loadDocList: ({ ordBookKey }) =>
    request.get(endpoints.simo(`loadDocList?ordBookKey=${ordBookKey}`)),
  downloadFile: ({ clientId, voucherId }) =>
    request.downloadFile(endpoints.simo('getVoucher?'), {
      clientId,
      voucherId,
    }),
  downloadFileF: ({ noteId }) =>
    request.downloadFile(endpoints.frameworkbo('DownloadAttach'), {
      noteId,
    }),
};
